import React, { useEffect, useState } from "react";
import {
  AppBar,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import { API } from "../../../../shared/services/api";
import { Alert } from "@material-ui/lab";
import { useContactsState } from "../../contexts/contact/hook";

export default function MessageTemplate({ setText }) {
  const [error, setError] = useState();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);

  const { currentContact } = useContactsState();

  async function loadMessages() {
    try {
      const result = await API.get(
        `customers/${currentContact.id}/message_templates`
      );

      setError(null);
      setMessages(result.data);
    } catch (e) {
      setError(
        <Alert variant="outlined" severity="error">
          Não foi possível carregar as mensagens prontas
        </Alert>
      );
    }
  }

  function handleClose() {
    setOpen(false);
  }

  function handleClick(message) {
    setOpen(false);
    setText(message.text);
  }

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <AppBar position="static" color="primary" elevation={1}>
          <Toolbar>
            <Typography color="inherit" variant="subtitle1">
              Mensagens prontas
            </Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent>
          {!!error && error}
          <List>
            {messages.map((message) => (
              <ListItem
                key={message.id}
                button
                onClick={() => handleClick(message)}
              >
                <ListItemText primary={message.name} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>

      <IconButton
        onClick={() => {
          setMessages([]);

          loadMessages();

          setOpen(true);
        }}
      >
        <Add />
      </IconButton>
    </>
  );
}
